import React from "react";

import "./PartnersPart.scss";

export const PartnersPart: React.FC = React.memo(() => {
  return (
    <div className="partners-part">
      <div className="partners-part__content">
        <div className="partners-part__content_title">Technological Basis</div>
        <div className="partners-part__content_logos">
          <div className="logo-row">
            <div className="wax-logo" />
            <div className="atomic-hub-logo" />
            <div className="atomic-assets-logo" />
          </div>
          
        </div>
      </div>
    </div>
  );
});
